var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"container__content__body",class:_vm.wide ? 'w-[1530px]' : 'w-[1200px]'},[_c('div',{staticClass:"container__content__body__slot",class:_vm.wide ? 'w-[1530px]' : 'w-[1200px]'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }